import { IDeveloperField } from 'dromo-uploader-react'

export const createSelectField = (
  key: string,
  label: string,
  selectOptions: any[],
  validators: any[] = [],
  hidden = false,
  invalidValueMessage = `Invalid ${label}`,
): IDeveloperField => ({
  key,
  label,
  type: 'select',
  selectOptions,
  validators,
  hidden,
  invalidValueMessage,
})
